import { render, staticRenderFns } from "./EventNew.vue?vue&type=template&id=48ec8ee9"
import script from "./EventNew.vue?vue&type=script&lang=js"
export * from "./EventNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports